import React from 'react'

export default () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 14 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g strokeWidth="2" stroke="#454545" fill="none" fillRule="evenodd">
      <path d="M10 18.133V3l3.33 3.33M4.33 2v15.133L1 13.803" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/sortIcon.js